import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants/urls";
import type { BackendSessionResponse } from "@memorang/types";
import type {
	CreateSessionRequest,
	EndSessionRequest,
	EndSessionResponse,
	TrackAnswerEventRequest,
	TrackAnswerEventResponse,
} from "./types";

type UpdateSessionBreakRequest = {
	sessionId: number;
	config: {
		allotedTime: number;
		section: string;
		startTime: string;
		status: string;
		totalBreakTimeTakenInSeconds: number;
	}[];
};

export const updateSessionBreak = async (
	payload: UpdateSessionBreakRequest,
): Promise<void> => {
	const { data } = await apiAxios.post(API_ENDPOINTS.BREAK_EVENTS, payload);

	return data.data;
};

export async function createSession(
	request: CreateSessionRequest,
): Promise<BackendSessionResponse> {
	const { data } = await apiAxios.post(API_ENDPOINTS.SESSIONS, request, {
		headers: {
			"Content-Type": "application/json",
		},
	});

	return data.data;
}

export async function endSession(
	request: EndSessionRequest,
): Promise<EndSessionResponse> {
	const { data } = await apiAxios.post(
		API_ENDPOINTS.SESSION_END(request.sessionId),
	);
	return data.data;
}

export async function trackAnswerEvent(
	request: TrackAnswerEventRequest,
): Promise<TrackAnswerEventResponse> {
	const { data } = await apiAxios.post(API_ENDPOINTS.ANSWER_EVENTS, request, {
		headers: {
			"Content-Type": "application/json",
		},
	});

	return data.data;
}
export const fetchSessionItems = async ({
	sessionId,
}: {
	sessionId: number;
}): Promise<BackendSessionResponse> => {
	const { data } = await apiAxios.get(API_ENDPOINTS.SESSION_ITEMS(sessionId));
	return data.data;
};
